import { fetchWithAuth } from "../fetchWithAuth";

const API_URL = process.env.REACT_APP_API_URL;

export const CreateChatService = async (question, token, thread_id, companySelected) => {
  try {
    const response = await fetchWithAuth(`${API_URL}/chat`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
      body: JSON.stringify({ question, thread_id, "company_id": companySelected }),
    });

    if (!response || !response.ok) {
      return {"error": true, "content": null};
    }

    return {"error": false, "content": await response.json()};
  } catch (error) {
    return {"error": true, "content": null};
  }
};
